import {
  useSuspenseGetAccounts,
  useSuspenseGetBuyerOutstandingPrincipal,
} from '../../../api/lending/lapiHooks.suspense';

export function useSuspenseOutstandingPrincipal() {
  const {
    accounts: { accounts },
  } = useSuspenseGetAccounts();
  const buyerOutstandingPrincipal = useSuspenseGetBuyerOutstandingPrincipal();

  const nonIwocapayPrincipal = accounts
    .filter((account) => account.product_type !== 'iwocapay')
    .reduce(
      (acc, account) => acc + (account.pending_balance?.principal ?? 0),
      0,
    );

  return nonIwocapayPrincipal + buyerOutstandingPrincipal;
}
